import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import PageTemplate from '../components/PageTemplate';
import axios from 'axios';

const API_URL = 'https://aamirsaba.com/api';

const DynamicPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/pages/${slug}`)
      .then(response => {
        console.log('Page loaded:', response.data);
        setPage(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading page:', error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <section className="pt-32 pb-20 bg-navy min-h-screen">
        <div className="container mx-auto px-6 text-center">
          <div className="text-cyan text-xl">Loading...</div>
        </div>
      </section>
    );
  }

  if (!page) {
    return (
      <section className="pt-32 pb-20 bg-navy min-h-screen">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold text-white">Page Not Found</h1>
          <p className="text-gray-400 mt-4">The page you're looking for doesn't exist.</p>
          <Link to="/" className="inline-block mt-6 text-cyan hover:underline">← Back to Home</Link>
        </div>
      </section>
    );
  }

  return (
    <PageTemplate title={page.title} lastUpdated={new Date(page.updatedAt).toLocaleDateString()}>
      <div className="bg-darkNavy p-6 rounded-xl border border-gray-800">
        <div className="text-gray-300" dangerouslySetInnerHTML={{ __html: page.content }} />
      </div>
    </PageTemplate>
  );
};

export default DynamicPage;
